export default __webpack_public_path__ + "static/media/entrepriseRetexLogo.b1e612ae.png";